import { render } from "./barcodeScaleSetup.vue?vue&type=template&id=ea5c1422"
import script from "./barcodeScaleSetup.vue?vue&type=script&lang=js"
export * from "./barcodeScaleSetup.vue?vue&type=script&lang=js"

import "./barcodeScaleSetup.vue?vue&type=style&index=0&id=ea5c1422&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__